import {
  triggerCustomEvent,
  setSessionVar,
  removeSessionVar,
  getSessionVar,
} from "./helpers/helpers";

const handleGravityFormEvent = (data) => {
  const { event, form_id, form_title } = data;

  let dataLayerEventData = {
    event_label: `${form_id}:${form_title}`,
    form_id,
    form_name: form_title,
    form_title,
  };

  switch (event) {
    case "form_view":
      dataLayerEventData = {
        ...dataLayerEventData,
        form_action: "form_view",
      };
      triggerCustomEvent(dataLayerEventData, "gf_view_event");
      break;

    case "form_start":
      dataLayerEventData = {
        ...dataLayerEventData,
        form_action: "form_start",
      };
      triggerCustomEvent(dataLayerEventData, "gf_start_event");
      break;

    case "form_submit_success":
      dataLayerEventData = {
        ...dataLayerEventData,
        form_action: "form_submit_success",
      };
      triggerCustomEvent(dataLayerEventData, "gf_submit_success_event");
      break;

    case "form_error":
      const errorMessage = getGFErrorMessage();

      dataLayerEventData = {
        ...dataLayerEventData,
        form_action: "form_error_view",
        error_message: errorMessage,
      };
      triggerCustomEvent(dataLayerEventData, "gf_error_event");
      break;

    default:
      break;
  }
};

const getGFData = (elm) => {
  const formId = elm ? elm.id.replace("gform_", "") : null;
  const formTileElm = document.querySelector(
    `#gform_wrapper_${formId} .gform_title`
  );
  const formTitle = (formTileElm && formTileElm.innerText) || "";

  return {
    formId,
    formTitle,
  };
};

const getGFErrorMessage = () => {
  const errorMessageElem = document.querySelector(".gform_validation_errors");
  const errorMessage = (errorMessageElem && errorMessageElem.innerText) || "";

  return errorMessage;
};

const isAjaxGFform = (form) => {
  const targetAttr = form?.getAttribute("target") || "";
  return /gform_ajax_frame/.test(targetAttr);
};

const isNewsletterForm = (form) => {
  return [...form.elements].some(element => element?.value?.toLowerCase()?.includes("newsletter"));
};

const checkFailedSubmission = (params) => {
  if (!params || !params.form_id) {
    return false;
  }

  const selector = `#gform_${params.form_id}[novalidate]`;
  return !!document.querySelector(selector);
};

const getEmailEhash = (form) => {
  const emailField = form.querySelector("[type=\"email\"]");
  const emailValue = emailField.value;

  if (emailValue && window.toEhashAsync) {
    return window.toEhashAsync(emailValue);
  }

  return Promise.resolve("");
};

const gravityFormInViewEvent = () => {
  const form = document.querySelector(".gform_wrapper form");
  const storageKey = "wvusGFData";

  const confirmationSession = getSessionVar(storageKey);
  const hasConfirmationData =
    (confirmationSession && !!confirmationSession.event) || false;

  if (form) {
    const formElFirstInput = document.querySelector(
      ".gform_wrapper form input:not([type=hidden])"
    );
    const errorContainer = document.querySelector(".gform_validation_errors");
    const { formId, formTitle } = getGFData(form);

    let observer = new IntersectionObserver(
      (entries, observer) => {
        let eventFired = false;

        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0 && !eventFired) {
            eventFired = true;

            handleGravityFormEvent({
              event: "form_view",
              form_id: formId,
              form_title: formTitle,
            });
            observer.unobserve(form);
          }
        });
      },
      { threshold: 1 }
    );

    observer.observe(form);

    //First Click
    const handleFirstFieldClick = function (e) {
      handleGravityFormEvent({
        event: "form_start",
        form_id: formId,
        form_title: formTitle,
      });

      formElFirstInput.removeEventListener("click", handleFirstFieldClick);
    };

    if (!errorContainer && !hasConfirmationData && formElFirstInput) {
      // Fires once and is then removed
      formElFirstInput.addEventListener("click", handleFirstFieldClick);
    }

    window?.jQuery(document)?.on("gform_confirmation_loaded", (e, formId) => {
      const dataLayerEventData = getSessionVar(storageKey);

      if (dataLayerEventData.form_id) {
        triggerCustomEvent(dataLayerEventData, "gf_newsletter_event");
      }

      removeSessionVar(storageKey);
    });

    window?.jQuery(document)?.on("gform_post_render", (e, formId) => {
      setTimeout(() => {
        if (window.document.querySelectorAll(`#gform_${formId}[novalidate]`).length) {
          const { event, form_id, ...eventParams } = getSessionVar(storageKey);

          form_id && handleGravityFormEvent({
            event: "form_error",
            form_id: form_id,
            ...eventParams
          });

          removeSessionVar(storageKey);
        }
      }, 1000);
    });

    // Submit Handler
    form.addEventListener("submit", (event) => {
      let trackingParams = {};

      if (isNewsletterForm(event.target)) {
        // Do Something with the Newsletter Form
        getEmailEhash(form).then((ehash) => {
          const formId = (/_(\d+)$/.exec(event.target.id)||[])[1]||"";

          trackingParams = {
            event: "newsletter_signup",
            event_action: "newsletter_signup_success",
            event_category: "newsletter_signup",
            event_label: "newsletter_signup_bar",
            ehash: ehash,
            form_id: formId,
            form_title: formTitle,
            form_name: "newsletter",
            form_title: "newsleter",
            hi_form_submissions: "1",
            high_intent_interactions: "1"
          };

          setSessionVar(storageKey, trackingParams);
        });
      } else {
        trackingParams = {
          event: "form_submit_click",
          form_id: formId,
          form_title: formTitle
        };

        setSessionVar(storageKey, trackingParams);
      }

      
    });

    if (!isAjaxGFform(form) && hasConfirmationData) {
      if (!checkFailedSubmission(confirmationSession)) {
        // Confirmation
        const submitTimeoutID = setTimeout(function () {
          if (hasConfirmationData) {
            const { event, ...eventParams } = confirmationSession;
            handleGravityFormEvent({
              event: "form_submit_success",
              ...eventParams
            });
            removeSessionVar(storageKey);
          }
          clearTimeout(submitTimeoutID);
        }, 500);
      } else {
        // Error handler
        const timeoutID = setTimeout(function () {
          if (errorContainer) {
            handleGravityFormEvent({
              event: "form_error",
              form_id: formId,
              form_title: formTitle,
            });
            removeSessionVar(storageKey);
          }
          clearTimeout(timeoutID);
        }, 500);
      }
    }
  }
};

export { gravityFormInViewEvent };
export default gravityFormInViewEvent;
